module.exports = __webpack_public_path__ + "static/media/kunshan02.3997efdf.jpg";